// --- Our Modules --------------------------------------------------------------------------------
import { pressToOpen } from "@/utils";
import Icon from "@/UI/atoms/Icon";
import type { TyIconName } from "@/UI/atoms/Icon/types";
import "./row.css";
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
type Props = {
    value: string | number;
    label: string;
    icon?: TyIconName;
    /** Makes the whole tile the target, like every other card in the app. Absent where it counts something with no screen of its own. */
    onOpen?: () => void;
};

/** The figure tiles across the top of a dashboard. Presentational — the screen counts, this shows. */
export default function StatCard({ value, label, icon = "stat", onOpen }: Props) {
    return (
        <article
            className={`stat-card${onOpen ? " stat-card--opens" : ""}`}
            role={onOpen ? "button" : undefined}
            tabIndex={onOpen ? 0 : undefined}
            onClick={onOpen}
            onKeyDown={onOpen ? pressToOpen(onOpen) : undefined}
        >
            <span className="stat-card__icon">
                <Icon name={icon} size={22} />
            </span>
            <div className="stat-card__text">
                <strong className="stat-card__value">{value}</strong>
                <span className="stat-card__label">{label}</span>
            </div>
        </article>
    );
}
